(function ($) {

	"use strict";

	$.enhancer("dismissableToast", function () {

		$(this).on('hidden.bs.toast', (e) => {
			$.cookies.set($(e.currentTarget).attr("data-dismissable-id") + "-closed", "true");
		});

	});

})(jQuery);